<template>
    <v-row class="row--large">
        <v-col cols="4" lg="auto" v-for="{ text, value } in items" :key="text">
            <v-sheet>
                <p class="page-text--sm grey-9--text mb-4">{{ text }}</p>
                <h5 class="page-text--lg font-weight-medium">{{ value }}명</h5>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        value: { type: Object, default: () => ({}) }, // meeting
    },
    computed: {
        items() {
            return [
                { text: "인원", value: this.value?._applications?.length || 0 },
                { text: "일자", value: this.value?.meta?.count?.schedulesResponded || 0 },
                { text: "미확인", value: this.value?.meta?.count?.schedulesToConfirm || 0 },
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    ::v-deep .v-sheet {
        width: 78px;
        max-width: 78px;
    }
}
@media (min-width: 1200px) {
}
</style>
